export class RouterBeforeTaskItem {
  tag;
  _routerNext;
  isDestroyed;

  constructor(tag, _routerNext) {
    this.tag = tag;
    if (_routerNext != null) {
      this._routerNext = _routerNext;
    } else {
      this._routerNext = null;
    }
  }

  routerNext() {
    if (!this.isDestroyed && this._routerNext) {
      return this._routerNext();
    }
    return true;
  }

  destroyed() {
    this.isDestroyed = true;
  }
}

export class RouterBeforeTask {
  pageList = [];
  modalList = [];

  pushPage(task) {
    this.pageList.push(task);
  }

  pushModal(task) {
    this.pageList.push(task);
  }

  clear() {
    this.pageList = [];
    this.modalList = [];
  }

  // 라우터 진행 가능 여부 검사
  isRouterNext() {
    if (!RouterBeforeTask.isRouterNextFromList(this.modalList)) {
      return false;
    }

    return RouterBeforeTask.isRouterNextFromList(this.pageList);
  }

  // 라우터 진행 가능 여부 검사
  static isRouterNextFromList(list) {
    const length = list.length;
    if (length > 0) {
      for (let i = 0; i < length; i++) {
        const task = list.pop();
        const isRouterNext = task.routerNext();
        if (!isRouterNext) {
          console.log("진행불가 : ", task);
          list.push(task);
          return false;
        }
      }
    }
    return true;
  }
}
